import { c as _c } from "react/compiler-runtime";
import type { CartOutputDto, EstimatedShippingAreaDto } from "@sticker-giant/sg-frontend-common";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { CART_ACTIVE_FILTER } from "@/queries/useCart";
import { useGlobalStore } from "@/stores/useGlobalStore";
import { useServicesStore } from "@/stores/useServicesStore";
import type { Location } from "@/types/vendors/Ipregistry";
export const estimatedShippingMutationKey = ["estimatedShipping"] as const;
function toEstimatedShippingAreaDto(location: Location): EstimatedShippingAreaDto {
  return {
    city: location.city,
    country: location.country.name,
    latitude: location.latitude === null ? null : String(location.latitude),
    longitude: location.longitude === null ? null : String(location.longitude),
    postalCode: location.postal,
    state: location.region.code
  };
}
export function useEstimatedShippingArea() {
  const $ = _c(8);
  const cartClient = useServicesStore(_temp);
  const cartId = useGlobalStore(_temp2);
  const queryClient = useQueryClient();
  let t0;
  if ($[0] !== cartClient || $[1] !== cartId) {
    t0 = async location => {
      if (!cartClient) {
        throw new Error("Cart client is not available.");
      }
      if (!cartId) {
        throw new Error("Cart id is not available.");
      }
      return await cartClient.postEstimatedShippingArea(cartId, toEstimatedShippingAreaDto(location));
    };
    $[0] = cartClient;
    $[1] = cartId;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== queryClient) {
    t1 = cart => {
      queryClient.setQueriesData(CART_ACTIVE_FILTER, cart);
    };
    $[3] = queryClient;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== t0 || $[6] !== t1) {
    t2 = {
      mutationKey: estimatedShippingMutationKey,
      mutationFn: t0,
      onSuccess: t1,
      onError: _temp3
    };
    $[5] = t0;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return useMutation(t2);
}
function _temp3() {
  console.error("Failed to post estimated shipping area");
}
function _temp2(state_0) {
  return state_0.cartId;
}
function _temp(state) {
  return state.cartClient;
}